export default {
    bike: 'bike',
    'bike-hire': 'bike',
    bus: 'bus',
    car: 'car',
    carclub: 'car-club',
    cycle: 'bike',
    ferry: 'ferry',
    'intercity bus': 'bus',
    'community transport': 'community-transport',
    'own car': 'car',
    'light tram': 'tram',
    subway: 'subway',
    train: 'train',
    tram: 'tram',
    taxi: 'taxi',
    walk: 'walk',
}
